'use client';

import dynamic from 'next/dynamic';
import type { EChartsReactProps } from 'echarts-for-react';

// 动态导入 ReactECharts，禁用 SSR
const ReactECharts = dynamic(() => import('echarts-for-react'), {
  ssr: false,
  loading: () => <div style={{ height: '100%', width: '100%' }} />,
});

interface DynamicReactEChartsProps extends EChartsReactProps {
}

/**
 * 动态加载的 ECharts 组件包装器
 * 解决 Next.js App Router 中的 SSR 和 async/await 问题
 */
export default function DynamicReactECharts(props: DynamicReactEChartsProps) {
  return <ReactECharts {...props} />;
}
